import { useTranslation } from 'react-i18next';
import { renderIcon } from '@/utils/iconRenderer';

function Notifications({
  notifications,
  isShowNotifications,
  setNotificationsClick
}) {
  const { t } = useTranslation();

  return (
    <>
      {/* Arkaplan gölgeleme alanı */}
      <div
        className={`fixed inset-0 bg-gray-900 bg-opacity-50 ${
          isShowNotifications ? 'block' : 'hidden'
        }`}
        onClick={() => setNotificationsClick()}></div>

      {/* Bildirimler Modali */}
      <div
        className={`absolute right-0 mt-[60px] ml-2 mr-2 max-w-lg mx-auto bg-white border border-gray-300 rounded-lg shadow-2xl p-4 z-20 ${
          isShowNotifications ? 'block' : 'hidden'
        }`}>
        <div
          id="notification-header"
          className="flex flex-row items-center justify-start bg-color-header-menu gap-2 p-3 border-b text-white">
          {renderIcon('notifications', 30, 'text-white')}
          <p className="ml-2 text-lg font-semibold">{t('Bildirimler')}</p>
        </div>

        <div className="max-h-72 overflow-auto my-3">
          {notifications.map((notification) => (
            <div
              className="flex items-start p-3 m-1 bg-gray-100 rounded shadow-md"
              key={notification.reCno}>
              {/* Sol tarafta icon veya resim */}
              <img
                src={notification.image}
                alt=""
                className={`w-10 h-10 rounded-full mr-3 ${
                  notification.status === 0
                    ? 'border-2 border-color-button'
                    : ''
                }`}
              />

              {/* Sağ tarafta içerik */}
              <div className="flex flex-col justify-center">
                <p
                  className={`text-sm ${
                    notification.status === 0 ? 'font-semibold' : ''
                  } text-gray-800`}>
                  {notification.title}
                </p>
                <p className="text-sm text-gray-600 mt-1">
                  {notification.detail}
                </p>
              </div>

              {/* Okunmamış bildirim göstergesi */}
              {notification.status === 0 && (
                <span className="ml-auto w-3 h-3 bg-color-button rounded-full self-center"></span>
              )}
            </div>
          ))}
        </div>

        <div className="flex justify-center p-4 border-t border-gray-200">
          <button className="flex items-center justify-center bg-color-button text-white w-full py-2 rounded transition-colors duration-300 hover:bg-color-button-hover">
            {renderIcon('domain-verification', 18, 'text-white')}
            <p className="ml-2 text-sm">{t('TumunuGoruntule')}</p>
          </button>
        </div>
      </div>
    </>
  );
}

export default Notifications;
